import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import { FoodsIconButton } from "@foodpilot/foods";

export type DefaultValueButtonProps = {
    onClick: () => void;
};
export const DefaultValueButton = (props: DefaultValueButtonProps) => {
    const { t } = useTranslation();

    return (
        <FoodsIconButton
            buttonProps={{
                onClick: props.onClick,
            }}
            tooltip={{
                text: (
                    <Box padding="8px" textAlign="center">
                        <Typography variant="body">{t("reinitialiser_la_valeur_par_defaut")}</Typography>
                    </Box>
                ),
            }}
            size={"m"}
            icon={"reset"}
        />
    );
};
